/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisTaskViewModel } from './OasisTaskViewModel'; 

export function getOasisTaskOptions(oasisTaskId: string, onSuccess?: (result: OasisTaskViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-task', oasisTaskId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getoasistask/' + oasisTaskId;
			const resp = await axios.get<OasisTaskViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(oasisTaskId)
	});
}